import { render, staticRenderFns } from "./OsInputSelect.vue?vue&type=template&id=57307c42&scoped=true"
import script from "./OsInputSelect.vue?vue&type=script&lang=ts"
export * from "./OsInputSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57307c42",
  null
  
)

export default component.exports